import { Alert, AlertTitle, Link, Stack, Typography } from '@mui/material'
import NextLink from 'next/link'
import { pagesPath } from '~/lib/$path'
import { DateTime } from 'luxon'
import {
  CampaignScheduleType,
  CampaignStatus,
  useCampaignListQuery,
} from '~/generated/graphql'
import { decodeId } from '~/lib/convertId'

export const ReservableScheduleEmptyAlert = () => {
  const { data: approvedCampaigns, loading: approvedLoading } = useCampaignListQuery({
    variables: {
      campaignCountInput: {
        status: [CampaignStatus.Approved],
      },
      input: {
        status: [CampaignStatus.Approved],
      },
    },
  })

  const approvedTodoCampaigns =
    approvedCampaigns?.viewer.campaigns.filter(
      (campaign) =>
        campaign.scheduleType === CampaignScheduleType.ReservableSchedule &&
        campaign.hasReservableSchedule === false &&
        !(campaign.offerEnded != null && DateTime.fromISO(campaign.offerEnded) <= DateTime.local()), // 募集終了(やりとり中)は含まない
    ) ?? []

  if (approvedLoading) {
    return null
  }
  if (approvedTodoCampaigns.length === 0) {
    return null
  }
  return (
    <Alert severity="error" sx={{ whiteSpace: 'pre-wrap' }} variant="outlined">
      <Stack gap={1}>
        <AlertTitle>来店可能日時が未設定のキャンペーンがあります</AlertTitle>
        インフルエンサーが日程提案できません。{'\n'}
        以下のキャンペーンの来店可能日時を設定してください。
        {approvedTodoCampaigns.length > 0 && (
          <Stack>
            <Typography fontWeight="bold" component="span">
              公開済みキャンペーン
            </Typography>
            <ul>
              {approvedTodoCampaigns.map((campaign) => (
                <li key={campaign.id}>
                  <NextLink
                    href={pagesPath.campaigns._campaignId(decodeId(campaign.id).id).reservation.$url()}
                    passHref
                    legacyBehavior
                  >
                    <Link>{campaign.name}</Link>
                  </NextLink>
                </li>
              ))}
            </ul>
          </Stack>
        )}
      </Stack>
    </Alert>
  )
}
